import { createContext } from 'react';
import type { SupervisorFinding } from '@avisoma/shared';

/** Revert from an entity view. `null` (the default) hides every Revert button: page view, non-admins. */
export type FindingRevertHandle = { revert: (finding: SupervisorFinding) => void; busy: boolean };

export const FindingRevertContext = createContext<FindingRevertHandle | null>(null);
